import { render, staticRenderFns } from "./Hs2.vue?vue&type=template&id=6492968d&scoped=true&"
import script from "./Hs2.vue?vue&type=script&lang=js&"
export * from "./Hs2.vue?vue&type=script&lang=js&"
import style0 from "./Hs2.vue?vue&type=style&index=0&id=6492968d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6492968d",
  null
  
)

export default component.exports